// 生产接口
export default {
  //cookie域名
  DOMAIN_NAME: '.jianglaiwang.com',

  //二版接口
  WS_BASE_URL: 'wss://api.jianglaiwang.com/user',
  BASE_URL: 'https://api.jianglaiwang.com/mall/',

  //三版接口与文件上传
  BASE_URL_V3: 'https://api-3.jianglaiwang.com/api/',
  UPLOAD_URL: 'https://api-3.jianglaiwang.com/api/harbor/tencent/cloud/cos/',

  //前端项目地址
  LOGIN_URL: 'http://www.jianglaiwang.com',
  REDIRECT_URL: 'http://console.jianglaiwang.com',
  BACKSTAGE_URL: 'http://admin.jianglaiwang.com',

  //前台商城
  RECEPTION_URL: 'http://mall.jianglaiwang.com',

  //对象存储参数
  BUCKET: 'prod-jianglaiwang-1257889624',
  REGION: 'ap-shanghai',
  UPLOAD_DOMAIN: 'https://file-cos.jianglaiwang.com/',
  ACCESSPATH: 'upload/',

  isDebug: false
}



// WEBPACK FOOTER //
// ./src/config/production.config.js